import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const EmptyState = ({ 
  icon: Icon = DocumentTextIcon,
  title = "No data found",
  description = "There's nothing to display at the moment.",
  action,
  className = ""
}) => {
  return (
    <div className={`text-center py-8 ${className}`}>
      <Icon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 mb-4">{description}</p>
      {action && (
        <div className="mt-4">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
